<div class="employee-manager-wrapper">
  <!-- leaving for test purpouses-->
  <app-button-rectangle style="display: none; position: fixed; left: 50%; top: 0%"
                        text="log"
                        (click)="testLogInConsole()"></app-button-rectangle>
  <app-modal>
    <app-modal-header [title]="
        isAddMode
          ? (T.common.add_item | translate: { item: localisedEmployee })
          : (T.common.edit_item | translate: { item: localisedEmployee })
      "
                      (closed)="onClose()"
                      [showDelete]="!isAddMode"
                      (deleted)="deleteClicked()"></app-modal-header>
    <app-modal-body>
      <div class="employee-manager-body row">
        <div class="general-details col-12 col-lg-5">
          <div class="section-header mb-12 d-flex justify-content-between align-items-center">
            <span>{{ T.settings.employees_departments_org.manage_employee.general_details | translate }}</span>
            <div class="d-flex align-items-center">
              <app-checkbox id="isUserActive"
                            [isChecked]="employeeDetailsViewModel.isActive"
                            (checked)="setActiveUser($event)">
              </app-checkbox>
              <span class="ml-8">
                {{
                T.settings.employees_departments_org.manage_employee.active_user | translate
                }}
              </span>
            </div>
          </div>

          <div class="general-details__user-info" [formGroup]="form">
            <div class="mb-24">
              <app-text-field id="firstName"
                              [formGroup]="form"
                              formControlName="firstName"
                              [allowSpecialCharacters]="false"
                              [placeholder]="(T.common.first_name | translate) + '*'"
                              [maxLength]="80"
                              [useReactiveMessages]="true">
              </app-text-field>
            </div>
            <div class="mt-24 mb-24">
              <app-text-field id="lastName"
                              [formGroup]="form"
                              formControlName="surname"
                              [allowSpecialCharacters]="false"
                              [placeholder]="(T.common.surname | translate) + '*'"
                              [maxLength]="80"
                              [useReactiveMessages]="true">
              </app-text-field>
            </div>
            <div class="mt-24 mb-24">
              <app-text-field id="email"
                              [formGroup]="form"
                              formControlName="username"
                              [allowSpecialCharacters]="false"
                              [placeholder]="(T.settings.my_preferences.profile.email | translate) + '*'"
                              [disabled]="!isAddMode"
                              [helperText]="
                  T.settings.employees_departments_org.manage_employee.username_to_be_use_to_sign_in | translate
                "
                              [maxLength]="200"
                              [useReactiveMessages]="true"
                              [type]="'email'">
              </app-text-field>
            </div>
            <div class="mt-24 mb-8">
              <app-filter-dropdown-new id="department"
                                       [filterByModuleObjectType]="false"
                                       [filterType]="filterTypes.Department"
                                       [disableMargin]="true"
                                       [appliedFilters]="filters"
                                       [singleSelect]="true"
                                       [typeahead]="true"
                                       [currentlySelectedSettingValue]="selectedDepartmentId"
                                       (onFilterUpdate)="updateEmployeeDepartment($event)">
              </app-filter-dropdown-new>
              <div class="input-aditional-info">
                <span>
                  {{
                  T.settings.employees_departments_org.manage_employee.department_helper_text
                    | translate: { localisedDepartment: localisedDepartment }
                  }}
                </span>
              </div>
            </div>
            <div class="mt-24 mb-8" *ngIf="accountFixedFilter === fixedFilters.VenueZone">
              <app-filter-dropdown-new id="zone"
                                       [filterByModuleObjectType]="false"
                                       [filterType]="filterTypes.Zone"
                                       [disableMargin]="true"
                                       [appliedFilters]="filters"
                                       [singleSelect]="true"
                                       [typeahead]="true"
                                       [currentlySelectedSettingValue]="selectedZoneId"
                                       (onFilterUpdate)="updateEmployeeZone($event)">
              </app-filter-dropdown-new>
            </div>
          </div>








          <div class="general-details__roles general-details__user-info">
            <div class="section-header d-flex">
              {{ T.settings.employees_departments_org.manage_employee.admin_roles | translate }}
            </div>
            <div class="general-roles">
              <div class="single-general-role row">
                <div class="col-6 text-left general-role__name">
                  {{ T.settings.my_preferences.permissions.employee_roles.account_admin | translate }}
                </div>
                <div class="col-2">
                  <app-radio-button id="isAccountAdmin"
                                    [disabled]="!canAccessRole(employeeRoleTypes.Account_Admin)"
                                    [checked]="isInRole(employeeRoleTypes.Account_Admin)"
                                    (checkedChanged)="selectPrimaryRole(employeeRoleTypes.Account_Admin)">
                  </app-radio-button>
                </div>
                <div class="col-4 text-right general-role__more-info">
                  <app-button-transparent [app-tooltip]="{
                      title: T.settings.my_preferences.permissions.employee_roles.account_admin | translate,
                      message:
                        T.settings.employees_departments_org.manage_employee.account_admin_roles_information | translate
                    }"
                                          size="small"
                                          icon="error_outline"
                                          [text]="T.common.learn_more | translate"
                                          iconFontSize="16">
                  </app-button-transparent>
                </div>
              </div>
              <div class="single-general-role row">
                <div class="col-6 text-left general-role__name">
                  {{ T.settings.my_preferences.permissions.employee_roles.user_admin | translate }}
                </div>
                <div class="col-2">
                  <app-radio-button id="isUserAdmin"
                                    [checked]="isInRole(employeeRoleTypes.User_Admin)"
                                    [disabled]="!canAccessRole(employeeRoleTypes.User_Admin)"
                                    (checkedChanged)="selectPrimaryRole(employeeRoleTypes.User_Admin)">
                  </app-radio-button>
                </div>
                <div class="col-4 text-right general-role__more-info">
                  <app-button-transparent [app-tooltip]="{
                      title: T.settings.my_preferences.permissions.employee_roles.user_admin | translate,
                      message: T.settings.my_preferences.permissions.user_admin_role_information | translate
                    }"
                                          size="small"
                                          icon="error_outline"
                                          [text]="T.common.learn_more | translate"
                                          iconFontSize="16">
                  </app-button-transparent>
                </div>
              </div>
              <div class="single-general-role row">
                <div class="col-6 text-left general-role__name">
                  {{ T.settings.my_preferences.permissions.employee_roles.admin | translate }}
                </div>
                <div class="col-2">
                  <app-radio-button id="isAdmin"
                                    [checked]="isInRole(employeeRoleTypes.Admin)"
                                    [disabled]="!canAccessRole(employeeRoleTypes.Admin)"
                                    (checkedChanged)="selectPrimaryRole(employeeRoleTypes.Admin)">
                  </app-radio-button>
                </div>
                <div class="col-4 text-right general-role__more-info">
                  <app-button-transparent [app-tooltip]="{
                      title: T.settings.my_preferences.permissions.employee_roles.admin | translate,
                      message: T.settings.my_preferences.permissions.admin_role_information | translate
                    }"
                                          size="small"
                                          icon="error_outline"
                                          [text]="T.common.learn_more | translate"
                                          iconFontSize="16">
                  </app-button-transparent>
                </div>
              </div>
              <div class="single-general-role row">
                <div class="col-6 text-left general-role__name">
                  {{ T.settings.employees_departments_org.manage_employee.general_role | translate }}
                </div>
                <div class="col-2">
                  <app-radio-button id="isGeneralUser"
                                    [checked]="isInRole(employeeRoleTypes.General_User)"
                                    [disabled]="!canAccessRole(employeeRoleTypes.General_User)"
                                    (checkedChanged)="selectPrimaryRole(employeeRoleTypes.General_User)">
                  </app-radio-button>
                </div>
                <div class="col-4 text-right general-role__more-info">
                  <app-button-transparent [app-tooltip]="{
                      title: T.settings.employees_departments_org.manage_employee.general_role | translate,
                      message: T.settings.employees_departments_org.manage_employee.general_role_information | translate
                    }"
                                          size="small"
                                          icon="error_outline"
                                          [text]="T.common.learn_more | translate"
                                          iconFontSize="16">
                  </app-button-transparent>
                </div>
              </div>
            </div>
          </div>
          <div class="general-details__roles general-details__user-info">
            <div class="mb-8">
              <app-employee-user-groups-section [employee]="employeeDetailsViewModel"
                                                (onGroupsChanged)="changeEmployeeGroups($event)">
              </app-employee-user-groups-section>
            </div>
          </div>
        </div>
        <div class="module-permissions col-12 col-lg-6">
          <div class="section-header mb-12 d-flex">
            {{ T.settings.employees_departments_org.manage_employee.module_permissions | translate }}
          </div>
          <app-tabset [tabId]="selectedModuleTab">
            <app-tab [isTabVisible]="account.usePlanning" id="planning">
              <ng-template appTabHeading><span>{{ T.common.planning_module | translate }}</span></ng-template>
              <div *ngIf="account.usePlanning">
                <app-planning-employee-permissions #planningComponent
                                                   [employeeDetailsViewModel]="employeeDetailsViewModel"
                                                   [isAccountAdmin]="isAccountAdmin"
                                                   [isInPrimaryRole]="isInPrimaryRole"
                                                   [isDepartmentSelected]="!!selectedDepartmentId">
                </app-planning-employee-permissions>
              </div>
            </app-tab>
            <app-tab [isTabVisible]="account.showRiskAndIssues" id="risk">
              <ng-template appTabHeading><span>{{ T.common.risk_module | translate }}</span></ng-template>
              <div *ngIf="account.showRiskAndIssues">
                <app-risk-employee-permissions #riskComponent
                                               [employeeDetailsViewModel]="employeeDetailsViewModel"
                                               [isAccountAdmin]="isAccountAdmin"
                                               [isInPrimaryRole]="isInPrimaryRole"
                                               [isDepartmentSelected]="!!selectedDepartmentId"></app-risk-employee-permissions>
              </div>
            </app-tab>
            <app-tab [isTabVisible]="account.useIMS || account.useIMSOnly" id="control">
              <ng-template appTabHeading><span>{{ T.common.control_module | translate }}</span></ng-template>
              <div *ngIf="account.useIMS || account.useIMSOnly">
                <app-control-employee-permissions #controlComponent
                                                  [employeeDetailsViewModel]="employeeDetailsViewModel"
                                                  [isAccountAdmin]="isAccountAdmin"
                                                  [isInPrimaryRole]="isInPrimaryRole"
                                                  [isDepartmentSelected]="!!selectedDepartmentId">
                </app-control-employee-permissions>
              </div>
            </app-tab>
            <app-tab [isTabVisible]="account.useRunSheets" id="runsheets">
              <ng-template appTabHeading><span>{{ T.common.run_sheets_module | translate }}</span></ng-template>
              <div *ngIf="account.useRunSheets">
                <app-runsheet-employee-permissions #runsheetsComponent
                                                   [employeeDetailsViewModel]="employeeDetailsViewModel"
                                                   [isAccountAdmin]="isAccountAdmin"
                                                   [isInPrimaryRole]="isInPrimaryRole"
                                                   [isDepartmentSelected]="!!selectedDepartmentId"></app-runsheet-employee-permissions>
              </div>
            </app-tab>
            <app-tab [isTabVisible]="account.useSustainability" id="sustainability">
              <ng-template appTabHeading><span>{{ T.common.sustainability_module | translate }}</span></ng-template>
              <div *ngIf="account.useSustainability">
                <app-sustainability-employee-permissions #sustainabilityComponent
                                                         [employeeDetailsViewModel]="employeeDetailsViewModel"
                                                         [isAccountAdmin]="isAccountAdmin"
                                                         [isInPrimaryRole]="isInPrimaryRole">
                </app-sustainability-employee-permissions>
              </div>
            </app-tab>
          </app-tabset>
        </div>
      </div>
    </app-modal-body>
    <app-modal-footer>
      <div class="employee-manager-footer">
        <div class="footer-left-buttons d-none d-md-block">
          <app-button-rectangle *ngIf="!isAddMode"
                                size="large"
                                buttonTheme="danger"
                                [text]="T.common.delete | translate"
                                (clicked)="deleteClicked()"></app-button-rectangle>
        </div>
        <div class="footer-right-buttons d-flex">
          <app-button-rectangle class="d-none d-md-block"
                                style="margin-right: 16px"
                                size="large"
                                buttonTheme="white"
                                [text]="T.common.cancel | translate"
                                (clicked)="onClose()"></app-button-rectangle>
          <app-button-rectangle [disabled]="!form.valid"
                                style="margin-right: 16px"
                                size="large"
                                [text]="T.settings.employees_departments_org.manage_employee.save_user | translate"
                                [loading]="saveButtonLoader"
                                (clicked)="handleSaveAndSendClick(false)"></app-button-rectangle>
          <app-button-rectangle [disabled]="!form.valid"
                                size="large"
                                [text]="T.settings.employees_departments_org.manage_employee.save_and_send_invite | translate"
                                [loading]="saveButtonLoader"
                                (clicked)="handleSaveAndSendClick(true)"></app-button-rectangle>
        </div>
      </div>
    </app-modal-footer>
  </app-modal>

  <div *ngIf="isConfirmUserIdpVisible" class="popup-overlay">
    <div class="popup-content general-details__auth general-details__user-info">
      <div class="popup-content-title">
        {{ T.settings.employees_departments_org.auth_messages.auth_type | translate }}
      </div>
      <ul class="popup-content-sub_title">
        <li>{{ T.settings.employees_departments_org.auth_messages.tenant_set_to_auth | translate: { localisedAuthenticationType: account.hasIdp ? (T.settings.employees_departments_org.auth_messages.auth_type_sso | translate) : (T.settings.employees_departments_org.auth_messages.auth_type_mom_auth | translate) } }}</li>
        <!--If the users email domain is not federated display a message unless the user is an existing federated user.-->
        <li *ngIf="account.hasIdp && (!employeeConfirmViewModel.userDomainIsFederated || !externalIsAvailable) && !(employeeConfirmViewModel.userExistsInIdp && employeeConfirmViewModel.exisitngUserIsExternal)">
          {{T.settings.employees_departments_org.auth_messages.email_not_eligible | translate}}
        </li>
        <!--Always show for existing external users and only for existing internal users that have redeemed.-->
        <li *ngIf="employeeConfirmViewModel.userExistsInIdp && (employeeConfirmViewModel.exisitngUserIsExternal || employeeConfirmViewModel.existingUserRedeemed)">
          {{ T.settings.employees_departments_org.auth_messages.email_already_registered | translate: { localisedAuthenticationType: employeeConfirmViewModel.exisitngUserIsExternal ? (T.settings.employees_departments_org.auth_messages.auth_type_sso | translate) : (T.settings.employees_departments_org.auth_messages.auth_type_mom_auth | translate) } }}
        </li>
      </ul>
      <!--If the account has idp and the users domain can federate and its a new user or the user has not already been set up as external, then we have options to override the account setting-->
      <ng-container *ngIf="externalIsAvailable && employeeConfirmViewModel.userDomainIsFederated && (!employeeConfirmViewModel.userExistsInIdp || !employeeConfirmViewModel.exisitngUserIsExternal)">
        <!--If the user has configured their internal credentials then this can be overridden so they can authenticate using SSO so display checkbox else offer choice with radio buttons-->
        <div *ngIf="employeeConfirmViewModel.existingUserRedeemed; else chooseAuthType" class="invite-external-container popup-content-sub_title">
          <app-checkbox-with-label [label]="T.settings.employees_departments_org.auth_messages.change_using_type | translate: { localisedAuthenticationType: T.settings.employees_departments_org.auth_messages.auth_type_sso | translate }"
                                   id="inviteExternal"
                                   [indeterminate]="false"
                                   [intialState]="employeeDetailsViewModel.employeeHasIdp ? 'checked' : 'unchecked'"
                                   (clicked)="setOverrideAuthType(null)">
          </app-checkbox-with-label>
          <div *ngIf="employeeDetailsViewModel.employeeHasIdp" class="mt-8 invite-external-container-warning">
            <span class="m-r-5"><i class="material-symbols-outlined warning-symbol">warning</i></span>
            <span class="m-l-5">{{ T.settings.employees_departments_org.auth_messages.invite_using_sso_warning | translate }}</span>
          </div>
        </div>
      </ng-container>
      <div class="d-flex justify-content-end">
        <div class="footer-right-buttons d-flex">
          <app-button-rectangle style="margin-right: 16px"
                                size="large"
                                buttonTheme="white"
                                [text]="T.common.cancel | translate"
                                (clicked)="hideConfirmUserIdp()"></app-button-rectangle>
          <app-button-rectangle [disabled]="!form.valid"
                                size="large"
                                [text]="T.common.continue | translate"
                                [loading]="saveButtonLoader"
                                (clicked)="handleConfirmUserContinueClick()"></app-button-rectangle>
        </div>
      </div>
      <div *ngIf="!employeeDetailsViewModel.isActive" class="popup-content-footer">
        <span>{{ T.settings.employees_departments_org.auth_messages.inactive_users_will_become_active | translate }}</span>
      </div>
    </div>
  </div>

  <ng-template #chooseAuthType>
    <div class="col-12 authentication-type__more-info">
      <app-button-transparent [app-tooltip]="{
        title: T.settings.employees_departments_org.auth_messages.auth_type | translate,
        message: T.settings.employees_departments_org.auth_messages.choose_auth_type  | translate: { localisedAuthTypeSso: T.settings.employees_departments_org.auth_messages.auth_type_sso | translate, localisedAuthTypeMomAuth: T.settings.employees_departments_org.auth_messages.auth_type_mom_auth | translate }
      }"
                              size="small"
                              icon="error_outline"
                              [text]="T.common.learn_more | translate"
                              iconFontSize="16">
      </app-button-transparent>
    </div>
    <div class="authentication-types">
      <div *ngIf="externalIsAvailable" class="single-authentication-type row">
        <div class="col-9 text-end authentication-type__name">
          {{ T.settings.employees_departments_org.auth_messages.invite_using_type | translate: { localisedAuthenticationType: T.settings.employees_departments_org.auth_messages.auth_type_sso | translate } }}
        </div>
        <div class="col-3">
          <app-radio-button id="inviteExternal"
                            [checked]="employeeDetailsViewModel.employeeHasIdp"
                            (checkedChanged)="setOverrideAuthType(null)">
          </app-radio-button>
        </div>
      </div>
      <div class="single-authentication-type row">
        <div class="col-9 text-end authentication-type__name">
          {{ T.settings.employees_departments_org.auth_messages.invite_using_type | translate: { localisedAuthenticationType: T.settings.employees_departments_org.auth_messages.auth_type_mom_auth | translate } }}
        </div>
        <div class="col-3">
          <app-radio-button id="inviteInternal"
                            [checked]="!employeeDetailsViewModel.employeeHasIdp"
                            (checkedChanged)="setOverrideAuthType(null)">
          </app-radio-button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
